<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import TypographyItem from '@/components/Typography/TypographyItem.vue'

type Props = {
    remarks: string[]
}
defineProps<Props>()
</script>

<template>
    <StackLayout v-if="remarks?.length" class="command-arguments">
        <TypographyItem
            v-for="(remark, key) in remarks"
            :key="key"
            :label="`${remark}${key + 1 !== remarks?.length ? ', ' : ''}`" />
    </StackLayout>
</template>

<style scoped lang="scss">
.command-arguments {
    &.stack {
        flex-direction: row;
        flex-wrap: wrap;
    }
}
</style>
